import {
  Component,
  OnInit,
  ViewEncapsulation,
  Output,
  Input,
  EventEmitter,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'postcode-map-uk',
  templateUrl: './postcode-map-uk.component.html',
  styleUrls: ['./postcode-map-uk.component.css'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class PostcodeMapUKComponent implements OnInit {
  _datas: string[] = [];
  @Output() UKCodeChange: EventEmitter<string[]>;

  _ukDatas: string[] = [];
  @Input('ukDatas')
  public set ukDatas(value: string[]) {
    if (!value) {
      value = [];
    }
    this._ukDatas = value;

    //console.log("Changed datas: ", value);

    this.UKCodeChange.emit(value);
  }
  public get ukDatas(): string[] {
    return this._ukDatas;
  }

  constructor() {
    this.UKCodeChange = new EventEmitter<string[]>();
  }

  ngOnInit() {}

  selectAreas(allAreas: boolean) {
    if (!allAreas) {
      this.ukDatas = [];
    } else {
      // read all <text nodes and extract the area codes
      var uk = document.getElementById('tabUKPostcodes');
      if (uk) {
        var text = Array.from(uk.getElementsByTagName('text'));

        var codes = text.map((x) => {
          return x.innerHTML;
        });

        //console.log("Codes: ", codes);

        // fill the datas array with the codes
        this.ukDatas = codes;
      }
    }
  }

  SelectCode(code: string) {
    var indexOf = this.ukDatas.indexOf(code);
    if (indexOf < 0) {
      this.ukDatas.push(code);
    } else {
      this.ukDatas.splice(indexOf, 1);
    }
    //console.log(this.ukDatas)

    this.UKCodeChange.emit(this.ukDatas);
  }

  IsSelected(code) {
    return this.ukDatas.indexOf(code) >= 0;
  }
}
